const routes = {
    legals: '/legal-notice',
    terms: '/terms',
    cookies: '/cookies-policy',
    privacy: '/privacy-policy'
};

export default routes;
